module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Electric/Air-conditioning-4a113b4f1a7a38edf8d3fd5d6fb877f8.svg";